export default {"src":"/_next/static/media/spaceman.e211565e.svg","height":191,"width":241};